import * as types from './types';
import update from 'immutability-helper';
import { scheduleViewTabs } from './utils';

const initialState = {
  activeTab: scheduleViewTabs.list,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_TAB] = (state, action) => {
  return update(state, {
    activeTab: {
      $set: action.tab,
    },
  });
};

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
